<template>
    <div>
        <div id="pageHeader" class="col-lg-9 col-md-7 col-sm-12 col-xs-12">
            <h1>
                {{getPageHeaderMainText()}}
                <span class="hidden-xs" v-html="getPageHeaderSpanText()"></span><!-- Example label: Place Order -->
            </h1>
            {{appendTitleToPageHtmlHead()}}
        </div>
        <div id="ctaholder" class="col-lg-3 col-md-5 col-sm-12 hidden-xs">
            <div id="cta">
                <a  id="cta-ask" class="btn btn-primary btn-sm gaq" :href="'/' + getPageUrl(82)" data-track="questions|questions_ask_open|cart"  accesskey="a" target="_blank">
                    <i class="csi-iconfont csi-question normal"></i>
                    <span class="hidden-sm hidden-xs">{{ labels[33] }}</span><!-- label: Ask a Question -->
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import useCart from "../composables/useCart"
import useCheckout from "../composables/useCheckout"
import useCMS from "../../shared/composables/useCMS"

export default {
    name: 'PageHeader',
    setup (...[,{ root }]) {
        const { labels, getPageUrl } = useCMS();
        const { getPageHeaderMainText, getPageHeaderSpanText, appendTitleToPageHtmlHead } = usePageHeaderEls(labels, root.$route);

        return {
            labels,
            getPageUrl,
            getPageHeaderMainText,
            getPageHeaderSpanText,
            appendTitleToPageHtmlHead
        }
    }
}

function usePageHeaderEls (labels, route) {
    const { canOrder } = useCart();
    const { info: checkoutInfo } = useCheckout();
    const step = computed(() => route.name);

    const getPageHeaderMainText = () => {
        let text = '';

        switch (step.value) {
            case 'Ship Address':
            case 'Ship Method':
            case 'Billing':
            case 'Review':
                text = labels[1042]; //label: Secure Checkout
                break;
            case 'Complete':
                text = labels[1113]; //label: Order Submitted
                break;
            default:
                if (canOrder.value) {
                    text = labels[994]; //label: Shopping Cart
                } else {
                    text = labels[995]; //label: Quote List
                }
                break;
        }

        return text;
    }

    const getPageHeaderSpanText = () => {
        let text = '';

        switch (step.value) {
            case 'Ship Address':
                text = labels[1043]; //label: Shipping Address
                break;
            case 'Ship Method':
                text = labels[1062]; //label: Shipping Method
                break;
            case 'Billing':
                text = labels[1075]; //label: Payment &amp; Billing
                if (checkoutInfo.value.isQuote) {
                    text = text + ' - Quote #' + checkoutInfo.value.uuid;
                }
                break;
            case 'Review':
                text = labels[1089]; //label: Review Order
                if (checkoutInfo.value.isQuote) {
                    text = text + ' - Quote #' + checkoutInfo.value.uuid;
                }
                break;
            case 'Complete':
                text = labels[1114]; //label: Your order has been received
                if (checkoutInfo.value.isQuote) {
                    text = text + ' - Quote #' + checkoutInfo.value.uuid;
                }
                break;
            default:
                if (canOrder.value) {
                    text = labels[1711]; //label: Place Order
                } else {
                    text = labels[1782]; //label: Request product pricing
                }
                break;
        }

        return text;
    }

    const appendTitleToPageHtmlHead = () => {
        switch (step.value) {
            case 'Ship Address':
                document.title = labels[1042] + ' - ' + labels[1043]; //label: Secure Checkout - Shipping Address
                break;
            case 'Ship Method':
                document.title = labels[1042] + ' - ' + labels[1062]; //label: Secure Checkout - Shipping Method
                break;
            case 'Billing':
                document.title = labels[1042] + ' - ' + labels[1075]; //label: Secure Checkout - Payment &amp; Billing
                break;
            case 'Review':
                document.title = labels[1042] + ' - ' + labels[1089]; //label: Secure Checkout - Review Order
                break;
            case 'Complete':
                document.title = labels[1042] + ' - ' + labels[1114]; //label: Secure Checkout - Your order has been received
                break;
            case 'Cart':
                if (canOrder.value) {
                    document.title = labels[994] + ' - ' + labels[1711]; //label: Shopping Cart - Place Order
                } else {
                    document.title = labels[995] + ' - ' + labels[1782]; //label:Quote List  - Request product pricing
                }
                break;
        }
    }

    return {
        getPageHeaderMainText,
        getPageHeaderSpanText,
        appendTitleToPageHtmlHead
    }
}
</script>
